import * as Yup from 'yup';

export const initialValues = {
  godownName: '',
  gstin: '',
  Pincode: '',
  State: '',
  District: '',
  City: '',
  address: '',
  phone: '',
  email: '',
  personIncharge: '',
};

//doc date should be less than or equal to current date
//transport doc date should be more than or equal to current date

export const validationSchema = Yup.object({
  godownName: Yup.string().required('Godown Name required'),
  gstin: Yup.string()
    .max(15, 'Maximum 15 characters allowed')
    // .required('GSTIN is required.')
    .matches(/\d{2}[A-Z]{5}\d{4}[A-Z\d]{2}[A-Z]{1}[A-Z\d]{1}$/, 'Invalid GSTIN'),
  Pincode: Yup.string().required('Pincode required').length(6, '6 digits required'),
  State: Yup.string().required('State required'),
  District: Yup.string().required('District required'),
  // City: Yup.string().required('City required'),
  address: Yup.string().required('Address required'),
  // phone: Yup.string().required('Phone required'),
  email: Yup.string().matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'Invalid email'),
  // personIncharge: Yup.string().required('Person InCharge required'),
});
